export type DadnoChatMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  createdAt: string;
  loading?: boolean;
};

export type DadnoThreadSummary = {
  id: string;
  title: string;
  preview: string;
  updatedAt: string;
};

export type DadnoThread = DadnoThreadSummary & {
  messages: DadnoChatMessage[];
  attachmentName?: string;
};

const KEY = "nevisign.reader.dadno-threads.v1";

function readAll(): DadnoThread[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as DadnoThread[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(items: DadnoThread[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, 30)));
  } catch {
    /* ignore */
  }
}

export function listDadnoThreads(): DadnoThreadSummary[] {
  return readAll()
    .map(({ id, title, preview, updatedAt }) => ({ id, title, preview, updatedAt }))
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function getDadnoThread(id: string): DadnoThread | null {
  return readAll().find((t) => t.id === id) ?? null;
}

export function upsertDadnoThread(thread: DadnoThread): void {
  const items = readAll().filter((t) => t.id !== thread.id);
  items.unshift(thread);
  writeAll(items);
}

export function newDadnoThreadId(): string {
  return `dadno_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}
